<button class='{{ btnstyle }}'>
    <img *ngIf="icon" src="/assets/icons/{{ icon }}.svg" alt="">
    {{ label }}
</button>
